import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { Accordion } from '@material-ui/core';
import RequestInput from '../../components/RequestInput/RequestInput';
import useAuth from '../../../../hooks/useAuth';
import useDraftComment from '../../hooks/useDraftComment';
import { useLang } from '../../../../util/lang';

const ChangeRequestBox = () => {
    const { id: caseId } = useParams();
    const [isPlanUploaded, setIsPlanUploaded] = useState(false);
    const { patientInfoComment } = useSelector((state) => state.requestComment);
    const auth = useAuth();
    const role = auth.user?.role;
    const { draftRequestValue, isRequestUnsaved, getMessageLabel } = useDraftComment({ currentPlanId: 'NO_PLAN_ID' });
    const getLang = useLang();

    useEffect(() => {
        setIsPlanUploaded(patientInfoComment?.case_status === 'PLAN_UPLOADED');
    }, [patientInfoComment]);

    return (
        <>
            {isPlanUploaded && role === 'DR' && (
                <Accordion style={{ borderRadius: 4, boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.08)', overflow: 'hidden', }}>
                    <div style={{ padding: "8px 12px" }}>
                        <RequestInput
                            label={getMessageLabel(getLang('@global.caseStatus.CHANGE_REQUEST'), isRequestUnsaved)}
                            defaultValue={draftRequestValue}
                            type={'request'}
                            caseId={caseId}
                            updatedDate={undefined}
                            createdDate={undefined}
                            noTimeLimit={true}
                            byPassShowingSubmitButton={true}
                            showChangeRequestReminder={true}
                            planIdForDraftMsg={'NO_PLAN_ID'}
                        />
                    </div>
                </Accordion>
            )}
        </>
    );
};

export default ChangeRequestBox;
